import React, { useEffect, useState, useCallback } from 'react'
import InputMask from 'react-input-mask'
import { useBonusStoreManager } from 'context/HomeStore/Manager/BonusProvider/BonusProvider.manager'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import {
  Button,
  Grid,
  TextField,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box
} from '@material-ui/core'
import { useSnackbar } from 'notistack'
import debounce from 'lodash/debounce'
import moment from 'moment'
import { bonusTypes, forWhat } from 'constants/bonus'

const BonusesTab = () => {
  const { enqueueSnackbar } = useSnackbar()
  const {
    bonusStore: { list, loading, filter },
    bonusStoreFunc: { getListBonuses, onChangeFilter }
  } = useBonusStoreManager()

  const [phoneNumber, setPhoneNumber] = useState(filter?.phoneNumber || '')
  const [previousPhoneNumber, setPreviousPhoneNumber] = useState('')

  const debouncedFetchBonuses = useCallback(
    debounce(phone => {
      if (phone.length === 18) {
        getListBonuses()
      }
    }, 1000),
    [getListBonuses]
  )

  useEffect(() => {
    if (phoneNumber !== previousPhoneNumber) {
      setPreviousPhoneNumber(phoneNumber)
      debouncedFetchBonuses(phoneNumber)
    }

    return () => {
      debouncedFetchBonuses.cancel()
    }
  }, [phoneNumber, previousPhoneNumber, debouncedFetchBonuses])

  const handleInputChange = event => {
    const { value } = event.target
    setPhoneNumber(value)
    onChangeFilter({ target: { name: 'phoneNumber', value } })
  }

  const handleSearch = () => {
    if (phoneNumber.length !== 18) {
      return enqueueSnackbar('Введите корректный номер', { variant: 'warning' })
    }

    getListBonuses()
  }

  const renderTransactions = () => {
    if (list && list.transactions && list.transactions.length > 0) {
      return (
        <>
          <Box sx={{ display: 'flex', gap: 35, my: 3 }}>
            <Typography variant="h6">
              Баланс: {list.totalAmount.toString().thousandSeparator()} ₸
            </Typography>
            <Typography variant="h6">
              Баланс: {list.totalFrozen.toString().thousandSeparator()} ₸
            </Typography>
          </Box>

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Баланс</TableCell>
                  <TableCell>Телефон</TableCell>
                  <TableCell>Дата</TableCell>
                  <TableCell>Тип</TableCell>
                  <TableCell>За что</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {list.transactions.map(transaction => (
                  <TableRow key={transaction.id}>
                    <TableCell>{transaction.id}</TableCell>

                    <TableCell>
                      {transaction.transactionType === 'TRANSFER_OUT' ||
                      transaction.transactionType === 'EXPIRE' ||
                      transaction.transactionType === 'SPEND'
                        ? '-'
                        : '+'}
                      {transaction.amount.toString().thousandSeparator()} ₸
                    </TableCell>

                    <TableCell>{transaction.phoneNumber}</TableCell>

                    <TableCell>
                      {moment(transaction.transactionDate).format(
                        'DD MMMM YYYY hh:mm:ss'
                      )}
                    </TableCell>

                    <TableCell>{bonusTypes[transaction.transactionType]}</TableCell>
                    <TableCell>{forWhat[transaction.projectCode]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )
    } else {
      return <Typography variant="h6">Нет данных для отображения</Typography>
    }
  }

  return (
    <Box>
      <LoaderBackdrop loading={loading} />

      <Box style={{ position: 'relative', height: '70vh' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <InputMask
              mask="+7 (999) 999-99-99"
              maskChar={null}
              value={phoneNumber}
              onChange={handleInputChange}
            >
              {inputProps => (
                <TextField
                  {...inputProps}
                  fullWidth
                  label="Бонусы по телефону"
                  name="phoneNumber"
                />
              )}
            </InputMask>
          </Grid>

          <Grid item xs={12}>
            <Button variant="contained" color="primary" onClick={handleSearch}>
              Поиск
            </Button>
          </Grid>

          <Grid item xs={12}>
            {renderTransactions()}
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default BonusesTab
